import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  projects: [
    "Scoreboard",
    "Flight Booking",
    "Product Cart",
    "Book Store",
    "Blog Application",
    "Job Finder",
  ],
  //   projects: [],
  search: "",
};

const TaskSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    selecteProject: (state, action) => {
      if (!state.projects?.includes(action.payload)) {
        state.projects.push(action.payload);
      }
      
    },
    UnSelecteProject: (state, action) => {
      state.projects = state.projects.filter((project) => project != action.payload)
    },
    searchFilter: (state, action) => {
      state.search = action.payload;
    },
  },
});

export default TaskSlice.reducer;
export const { selecteProject, UnSelecteProject, searchFilter } =
  TaskSlice.actions;
